import Image from "next/image";

import bulletblue from "@/assets/img/how-it-works/bullet.svg";
import bulletpink from "@/assets/img/how-it-works/bullet_pink.svg";
import curveLineDown from "@/assets/img/redeem-partner/curve_line.svg";
import { PartnerConfigRedeem } from "@/services/contentful/categories";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { Box, Chip, Stack, Typography } from "@mui/material";

import { styles } from "./styles";

export const PartnerDisplay: React.FC<PartnerConfigRedeem> = ({ title, description, logo, tag }) => {
  return (
    <Stack
      display="flex"
      flexDirection={{ xs: "column", sm: "column", md: "row", lg: "row" }}
      gap={{ xs: 6, lg: 9 }}
      position="relative"
      bgcolor="#FFD100"
      mb={{ xs: tag ? "68px" : "136px", sm: tag ? "68px" : "136px", md: "68px" }}
      minHeight={{ xs: "308px", md: "30rem" }}
    >
      <Box flex={1} minWidth="40vw" maxWidth={{ xs: "100vw", sm: "100vw", md: "40vw", lg: "40vw" }} position="relative">
        <Box component="img" src={logo} alt="" css={styles.img_logo} />

        <Image src={bulletpink} alt="" css={styles.bullet_pink} />
      </Box>

      <Stack pl={{ xs: 3, lg: 0 }} pr={{ xs: 3, md: 4, lg: 10 }} justifyContent="space-between" spacing={{ xs: 16, md: 0 }}>
        <Stack flexDirection="row" width="100%" height={{ xs: "inherent", md: "70%" }} position="relative">
          <Stack mt={{ xs: 0, md: 6, lg: 8 }} gap={2} mr={{ xs: 0, md: "20px", lg: "50px" }}>
            <Typography fontWeight={600} fontSize={{ xs: 32, sm: 32, md: 36 }}>
              {title}
            </Typography>
            <Typography component="div" zIndex={3}>
              {documentToReactComponents(description)}
            </Typography>
          </Stack>

          <Image src={curveLineDown} alt="" css={styles.cuver_line} />
          <Box css={styles.vertical_line} />
          <Box css={styles.hotizontal_line} />

          <Image src={bulletblue} alt="" css={styles.bullet_blue} />
        </Stack>

        {tag && (
          <Stack display="flex" alignSelf={{ xs: "center", lg: "end" }}>
            <Chip
              label={<Typography component="div">{documentToReactComponents(tag)}</Typography>}
              sx={{
                bgcolor: "#FFB206",
                p: 1,
                borderRadius: { xs: "30px", md: "20px", lg: "30px" },
                minHeight: "32px",
                height: "auto",
                "& .MuiChip-label": {
                  display: "block",
                  whiteSpace: "normal"
                }
              }}
            />
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};
